// @flow

import * as React from 'react';
import Icon from 'components/Icon';
import classnames from 'classnames';

type Props = {|
    id: string,
    alt: string,
    number: number,
    className?: string,
    play?: boolean,
    onClick?: () => any
|};

const YoutubeThumb = ({
    id,
    alt,
    number,
    className,
    play = false,
    onClick
}: Props): React.Node => (
    <div className={classnames('YoutubeThumb', className)} onClick={onClick} role="button">
        {play && <Icon type="play" />}
        <img
            className="YoutubeThumb__image"
            src={`https://img.youtube.com/vi/${id}/${number}.jpg`}
            alt={alt}
        />
    </div>
);

export default YoutubeThumb;
